import { useEffect, useRef, useState } from "react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Digital Nomad",
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20traveler%20portrait%2C%20confident%20young%20woman%20in%20casual%20business%20attire%2C%20modern%20cafe%20background%2C%20natural%20lighting%2C%20professional%20photography&width=80&height=80&seq=shield001&orientation=squarish",
    text: "Online Shield has been essential for my work while traveling. The VPN connects instantly and I feel safe using public Wi-Fi in airports and hotels. The speed test feature helps me pick the best server every time.",
  },
  {
    name: "David Chen",
    role: "Software Developer",
    image: "https://readdy.ai/api/search-image?query=Professional%20male%20software%20developer%20portrait%2C%20confident%20tech%20professional%20in%20smart%20casual%20attire%2C%20modern%20office%20background%2C%20professional%20photography&width=80&height=80&seq=shield002&orientation=squarish",
    text: "The AdBlock feature is a game changer. Not only do I get a cleaner browsing experience, but pages load noticeably faster without all the tracking scripts. The IP checker gives me peace of mind knowing my real location is hidden.",
  },
  {
    name: "Emma Rodriguez",
    role: "Marketing Consultant",
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20marketing%20consultant%20portrait%2C%20confident%20businesswoman%20in%20stylish%20attire%2C%20modern%20office%20background%2C%20professional%20photography&width=80&height=80&seq=shield003&orientation=squarish",
    text: "I manage multiple client accounts and need to verify how websites appear from different locations. The VPN with 1000+ servers makes this effortless. The app is intuitive and the support team is incredibly responsive.",
  },
];

export default function TestimonialsCarousel() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startAutoPlay = () => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
  };

  const stopAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
  }, []);

  const goTo = (index: number) => {
    stopAutoPlay();
    setCurrent(index);
    startAutoPlay();
  };

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4 font-heading">
            Client Success Stories
          </h2>
          <p className="text-lg text-foreground-600 max-w-3xl mx-auto">
            Real experiences from users enjoying Online Shield — Fast VPN Proxy
          </p>
        </div>

        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${current * 100}%)` }}
          >
            {testimonials.map((t, idx) => (
              <div key={idx} className="w-full flex-shrink-0 px-4">
                <div className="bg-background-50 rounded-xl p-6 md:p-8 max-w-4xl mx-auto border border-background-200">
                  <div className="flex items-center mb-6">
                    <div className="w-14 h-14 rounded-full overflow-hidden mr-4 flex-shrink-0">
                      <img
                        src={t.image}
                        alt={t.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-foreground-900">{t.name}</h4>
                      <p className="text-foreground-600 text-sm">{t.role}</p>
                    </div>
                  </div>
                  <p className="text-lg text-foreground-700 italic leading-relaxed">
                    &ldquo;{t.text}&rdquo;
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center mt-8 space-x-2">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => goTo(idx)}
              className={`w-3 h-3 rounded-full transition-colors ${
                idx === current ? "bg-primary-500" : "bg-background-300"
              }`}
              aria-label={`Go to testimonial ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}